import moment from 'moment';
export { default as formatErrorMessage } from './formatErrorMessage';
export { default as fetchPostman } from './postman';

export function toAPIDateString(date: Date) {
	return moment(date).format('YYYY-MM-DD');
}
